import styled from "styled-components";

export const StyledSvg = styled.svg`
	display: inline-block;
	width: 80px;
	height: 80px;
`;

export const IconWrapper = styled.div`
	display: flex;
	justify-content: center;

	/* margin-top: 300px; */
	margin: ${({ margin }) => (margin ? "300px 0 0 0" : "0")};
`;
